import Swal from "sweetalert2";
import { api } from "../api/Middleware";
import { USERS_URL, BASE_URL } from "../api/Urls";
import { ERROR_MESSAGES } from "../helpers/ErrorMessages";
import { setCookie } from "nookies";
import jwt_decode from "jwt-decode";

export const ValidateCPF = async (data) => {
  try {
    let response = await api.post(USERS_URL + "validate_cpf/", data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const GetOne = async (id) => {
  try {
    let response = await api.get(USERS_URL + id + "/");
    return response.data;
  } catch (error) {}
};

export const GetAll = async (setUsers, setErrors, setIsLoading) => {
  try {
    let response = await api.get(USERS_URL + "get_superusers/");
    if (response.status === 200) setUsers(response.data);
  } catch (error) {
    setErrors({ title: "Oops!", message: ERROR_MESSAGES.categories.get });
  }

  setIsLoading(false);
};

export const Create = async (
  data,
  setData,
  setNotify,
  setError,
  returnData = false,
  firstAdmin = false,
  setProgress = false
) => {
  try {
    let response = await api.post(
      firstAdmin ? USERS_URL + "create_first_admin/" : USERS_URL,
      data
    );
    if (response.status === 200) {
      if (returnData) {
        return response.data;
      } else {
        //localStorage.setItem('user', JSON.stringify(response.data))
        setData(response.data);
        setNotify({
          title: "Sucesso!",
          message: "Usuário cadastrado com sucesso!",
          type: "success",
          visible: true,
        });
        setTimeout(
          () => {},
          [(window.location.href = BASE_URL + "users")],
          3000
        );
      }
    }
  } catch (error) {
    if (returnData) {
      return error.response;
    } else {
      if (error.response.status === 400) {
        if (
          error.response.data &&
          Object.keys(error.response.data).length > 0
        ) {
          Object.keys(error.response.data).forEach((key, index) => {
            console.log(key);
            console.log(index);
            setError(key, {
              message: error.response.data[key][0],
              type: "custom",
            });
          });
        }
      } else if (error.response.status === 401) {
        window.location.href = BASE_URL;
      } else {
        setNotify({
          title: "Oops!",
          message: error.response?.data,
          type: "error",
          visible: true,
        });
      }
    }
  } finally {
    if (setProgress) setProgress(false);
  }
};

export const Update = async (
  id,
  data,
  setUser,
  setNotify,
  setError = false,
  setProgress = false
) => {
  try {
    // Verifica se data é FormData e se contém o campo photo
    const hasPhoto =
      data instanceof FormData &&
      Array.from(data.entries()).some(
        (entry) => entry[0] === "photo" && entry[1].size > 0
      );

    // Configurações para a requisição, incluindo cabeçalhos apropriados para FormData
    const config = {
      headers: {
        "Content-Type": hasPhoto ? "multipart/form-data" : "application/json",
      },
    };

    // Log para depuração (pode ser removido em produção)
    if (hasPhoto) {
      console.log("Enviando foto para o servidor");
    }

    let response = await api.put(USERS_URL + id + "/", data, config);

    if (response.status === 200) {
      let token = response.data.access;

      setCookie(undefined, "token", token, {
        maxAge: 60 * 60 * 24 * 7, // 7 dias
      });

      let user = jwt_decode(token);

      // Remover campos desnecessários do token
      delete user.jti;
      delete user.exp;
      delete user.iat;
      delete user.token_type;

      // Salvar dados no storage
      sessionStorage.setItem("plan_id", user.plan_id);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("lastEmailLogged", user.user_email);

      setUser(user);

      setNotify({
        title: "Sucesso!",
        message: "Usuário atualizado com sucesso!",
        type: "success",
        visible: true,
      });
      // Redirecionar após atualização bem-sucedida
      setTimeout(() => {
        window.location.href = `/user-details/${user.user_id}`;
      }, 1500);

      return response.data; // Retorna os dados da resposta para uso no componente
    }
  } catch (error) {
    console.error("Erro ao atualizar usuário:", error);

    // Tratar erros de validação
    if (error.response && error.response.status === 400) {
      if (error.response.data && Object.keys(error.response.data).length > 0) {
        // Se setError for fornecido, registrar os erros de validação
        if (setError && typeof setError === "function") {
          Object.keys(error.response.data).forEach((key) => {
            setError(key, {
              message: error.response.data[key][0],
              type: "custom",
            });
          });
        }
      }
    } else {
      // Notificar erro geral se a função for fornecida
      if (setNotify && typeof setNotify === "function") {
        setNotify({
          title: "Oops!",
          message: ERROR_MESSAGES.users.update || "Erro ao atualizar usuário.",
          type: "error",
          visible: true,
        });
      }
    }

    // Rejeitar a promise para que o componente possa capturar o erro
    throw error;
  } finally {
    // Finalizar o indicador de progresso se a função for fornecida
    if (setProgress && typeof setProgress === "function") {
      setProgress(false);
    }
  }
};

export const ChangeStatus = async (data, setNotify, setProgress) => {
  setProgress(true);
  try {
    let response = await api.put(USERS_URL + data.id + "/", {
      is_active: parseInt(data.status),
    });
    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Status atualizado com sucesso!",
        type: "success",
        visible: true,
      });
      setProgress(false);
      return true;
    }
  } catch (error) {
    setNotify({
      title: "Oops!",
      message: ERROR_MESSAGES.orders.status,
      type: "error",
      visible: true,
    });
    setProgress(false);
    return false;
  }
};

export const Delete = async (id, setNotify, setProgress) => {
  setProgress(true);

  try {
    let ids = [id];

    let response = await api.delete(USERS_URL + "delete_multiple/", {
      data: { ids: ids },
    });
    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Operação realizada com sucesso!",
        type: "success",
        visible: true,
      });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  } catch (error) {
    //if(error.status !== 401) throw error.response;
    setNotify({
      title: "Oops!",
      message: error.response.data,
      type: "error",
      visible: true,
    });
  }

  setProgress(false);
};

export const GetUserCep = async (cep) => {
  try {
    let response = await api.get(`https://viacep.com.br/ws/${cep}/json/`);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const AccessStore = async (data) => {
  try {
    let response = await api.post(USERS_URL + "access_store/", data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    Swal.fire("Oops", error.response.data, "error");
  }
};

export const FilterUsersBy = async (payload) => {
  try {
    let response = await api.get(USERS_URL + "filter_by/?" + payload);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
